<template>
  <div class="home">
    <section id="header-home" class="d-flex align-items-center">
      <div class="container">
        <div class="row">
          <div class="col-10 offset-1 mb-5">
            <h1>PROCUROU • ACHOU • ECONOMIZOU!</h1>
            <h6 class="mb-5 align-center text-center">Compre consultas e exames médicos com o melhor preço, realize orçamento de exames e escolha entre milhares de prestadores na área da Saúde e Bem estar</h6>
            <form-busca></form-busca>
            <div v-if="formBusca.tipoPedido === 'Exame'" class="align-content-center mt-3 text-center">
              <router-link tag="a" class="btn btn-primary " :to="{name: 'Orcamento'}">Fazer orçamento de exames</router-link>
            </div>
          </div>
        </div>
      </div>
      <span style="cursor: pointer;" class="how-work-link" @click="scrollMeTo('ComoFunciona')">
            <small>Veja como Funciona</small>
            <i class="fas fa-sort-down"></i>
      </span>
    </section>
    <section id="como-funciona" class="d-flex align-items-center" ref="ComoFunciona">
      <div class="container">
        <div class="section-heading centered">
          <h3>
            Como Funciona
          </h3>
        </div>
        <div class="row">
          <div class="col-md-3 text-center">
            <div class="hw-item">
              <div class="img-item-hw">
                <img src="@/img/search-solid.svg" alt="Search">
              </div>
              <hr class="nbr-item n-1">
              <p>Faça uma busca pelo serviço desejado e local de atendimento</p>
            </div>

          </div>
          <div class="col-md-3 text-center">
            <div class="hw-item">
              <div class="img-item-hw">
                <img src="@/img/list-solid.svg" alt="List">
              </div>
              <hr class="nbr-item n-2">
              <p>Filtre por Nome, avaliação, preço ou localidade e escolha seu prestador de serviço com até 70% de economia</p>
            </div>

          </div>
          <div class="col-md-3 text-center">
            <div class="hw-item">
              <div class="img-item-hw">
                <img src="@/img/percentage-solid.svg" alt="Percent">
              </div>
              <hr class="nbr-item n-3">
              <p>Compre o serviço desejado e você receberá um VOUCHER DE ATENDIMENTO que será validado no local de atendimento pelo prestador escolhido</p>
            </div>

          </div>
          <div class="col-md-3 text-center">
            <div class="hw-item">
              <div class="img-item-hw">
                <img src="@/img/user-md-solid.svg" alt="Médico">
              </div>
              <hr class="nbr-item n-4">
              <p>Com o Dr.Achei você realiza orçamentos, avalia o serviço recebido e ainda tem a garantia de pagar o menor preço com compras realizadas através do nosso APP ou site.</p>
            </div>

          </div>
        </div>
      </div>
    </section>
    <section id="prices" class="d-flex align-items-center">
      <div class="container">
        <div class="section-heading centered">
                <h1>
                  Veja as Vantagens
                </h1>
              </div>
              <div class="d-block d-sm-none">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <h3><b>$</b></h3>
                    <h4>Cartão Dr.Achei Card </h4>
                    <p> *Plano empresarial : plano exclusivo para empresas e pessoas físicas vinculadas a uma empresa :
                      Adquira um plano vinculado a uma empresa e obtenha até 70% de desconto em consultas e exames. Planos a partir de R$21,90 por mês para você e mais 3 (três) dependentes.
                      *Verifique a empresa mais próxima a você ou faça ou plano para sua empresa </p>
                    <small>*12,90 por mês</small>
                    <small>Planos com a sua marca</small>
                    <button class="btn btn-primary btn-block mt-1" data-toggle="modal" data-target="#sinsaude">Saiba Mais</button>
                    <div class="modal fade" id="sinsaude" tabindex="-1" role="dialog" aria-labelledby="sinsaudeLabel" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="sinsaudeLabel">Vantagens Dr.Achei Card</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <p> Economize até 70% em consultas e exames e muito mais;</p>
                            <p>Cartão familiar válido para titular e mais três dependentes familiares;</p>
                            <p>Não tem carência,limite de idade e utilização;</p>
                            <p>Garantimos o menor preço;</p>
                            <p>Realize orçamento de consultas e exames em laboratórios e descubra o menor preço;</p>
                            <p>Obtenha o histórico de todos os atendimentos com banco de dados de prontuário médico e receituários;</p>
                            <p>Ganhe o Cartão Achei descontos e obtenha descontos em cinema, loja, supermercados e muito mais;</p>
                            <p>Agende suas consultas, exames e serviços online com menor preço;</p>
                            <p>Avalie seus atendimentos médicos;</p>
                            <p>Pagamento no ato de atendimento ou via Plataforma em até 10 vezes.</p>
                            <br>

                            <router-link tag="a" :to="{name: 'SinSaudeCard'}" data-dismiss="modal" class="btn btn-primary btn-rounded">Adquirir</router-link>
                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <h3><b>$$$</b></h3>
                    <h4>Dr. Achei </h4>
                    <h5>Sem Mensalidade</h5>
                    <p>Compre suas consultas, exames e serviços quando precisar pagando mais barato do que no local de atendimento com até 50% de desconto;</p>
                    <button class="btn btn-primary btn-block mt-1" data-toggle="modal" data-target="#drachei">Saiba Mais</button>
                     <div class="modal fade" id="drachei" tabindex="-1" role="dialog" aria-labelledby="dracheiLabel" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title" id="dracheiLabel">Vantagens Dr.Achei</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true">&times;</span>
                            </button>
                          </div>
                          <div class="modal-body">
                            <h3>Sem Mensalidade</h3>
                            <p>Compre por aqui seus serviços e ganhe até 50% de desconto em cima do preço do particular do local de atendimento;</p>
                            <p>Possuímos milhares de serviços na área de saúde e bem estar;</p>
                            <p>Facilitamos seu pagamento -parcele em até 10 vezes </p>
                            <p>Avalie seu atendimento médico;</p>
                            <p>Agende suas consultas online;</p>
                            <br>
                            <router-link tag="a" :to="{name: 'SinSaudeCard'}" data-dismiss="modal" class="btn btn-primary btn-rounded">Adquirir</router-link>

                          </div>
                          <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <h3><b class="text-center">$$$$$</b></h3>
                    <h4>Particular</h4>
                    <p>Pague diretamente no local de atendimento e pague o preço cheio sem desconto!</p>
                  </div>
                </div>
              </div>
              <div class="d-none d-sm-block">
                <div class="pricing-plans row no-gutters">
                <div class="pricing-plan col-sm-4 particular-plan">
                  <div class="plan-head">
                    <div class="plan-image">
                      <img alt="" src="@/img/stethoscope.svg">
                    </div>
                    <div class="plan-name">
                      Particular
                    </div>
                  </div>
                  <div class="plan-body">
                    <div class="plan-price-w">
                      <div class="price-value">
                        $$$$$
                      </div>
                    </div>
                  </div>
                  <div class="plan-description">
                    <h6>
                      Desvantagens;
                    </h6>
                    <ul>
                      <li>
                        Sem Economia;
                      </li>
                      <li>
                        Valor mais elevado.
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="pricing-plan col-sm-4 highlight sinsaude-plan">
                  <div class="plan-head">
                    <div class="plan-image">
                      <img src="@/img/brand-drachei-card.svg" alt="SinSaúde Card">
                    </div>
                  </div>
                  <div class="plan-body">
                    <div class="plan-price-w">
                      <div class="price-value">
                        $
                      </div>
                    </div>

                  </div>
                  <div class="plan-description">
                    <p>A partir de R$ 21,90 por mês</p>
                    <ul>
                      <li>
                        Economize até 70% em consultas e exames e muito mais;
                      </li>
                      <li>
                        Cartão familiar válido para titular e mais três dependentes familiares;
                      </li>
                      <li>
                        Não tem carência,limite de idade e utilização;
                      </li>
                      <li>
                        Garantia de menor preço;
                      </li>
                      <li>Orçamento de consultas e exames;</li>
                      <li>Histórico de todos os atendimentos com banco de dados de prontuário médico e receituários;</li>
                      <li>Cartão Achei descontos em cinema, loja, supermercados e muito mais;</li>
                      <li>Agendamento online;</li>
                      <li>Avalie seu atendimento médico;</li>
                      <li>Pagamento no ato de atendimento ou via Plataforma em até 10 vezes.</li>

                    </ul>
                  </div>
                  <div class="plan-btn-w">
                    <router-link tag="a" :to="{name: 'SinSaudeCard'}" class="btn btn-primary btn-rounded">Quero meu cartão</router-link>
                  </div>
                </div>
                <div class="pricing-plan col-sm-4 dr-achei-plan">
                  <div class="plan-head">
                    <div class="plan-image">
                      <img alt="" src="@/img/brand-drachei-vert.svg">
                    </div>
                  </div>
                  <div class="plan-body">
                    <div class="plan-price-w">
                      <div class="price-value">
                        $$$
                      </div>
                    </div>
                  </div>
                  <div class="plan-description">
                    <h6>
                      SEM MENSALIDADE
                    </h6>
                    <ul>
                      <li>
                        Pagamento através da Plataforma Dr Achei;
                      </li>
                      <li>
                        Pagamento avulso de consultas e exames;
                      </li>
                      <li>
                        Facilidade no pagamento;
                      </li>
                      <li>
                        Economize até 40% em cima do preço da rede credenciada;
                      </li>
                      <li>Avalie seu atendimento médico;</li>
                      <li>Agendamento online.</li>
                    </ul>
                  </div>
                </div>
              </div>
              </div>

      </div>
    </section>
    <section v-if="exibeConhecaNossosPlanos" id="sinsaude" class="d-flex align-items-center">
      <div class="container">
        <div class="section-heading centered">
          <h3>
            Conheça Nossos Planos
          </h3>
        </div>
        <div class="">
          <sin-saude-planos></sin-saude-planos>
        </div>

      </div>
    </section>

    <section id="depoimentos">
      <div class="section-heading centered">
        <h3>
          Depoimentos
        </h3>
      </div>
      <slick-depoimentos></slick-depoimentos>
    </section>
    <section id="parceiros">
      <div class="section-heading centered">
        <h3>
          Parceiros
        </h3>
      </div>
      <div class="container">
        <slick-unidades></slick-unidades>
      </div>
    </section>
    <!--<a href="#0" class="cd-top js-cd-top">Top</a>-->
  </div>
</template>

<script>
import FormBusca from '@/components/busca/FormBusca'
import SlickUnidades from '@/components/shared/SlickUnidades'
import SlickDepoimentos from '@/components/shared/SlickDepoimentos'
import eventBus from '@/event-bus'
import SinSaudePlanos from '@/components/shared/SinSaudePlanos'

export default {
  components: {
    'form-busca': FormBusca,
    SlickUnidades,
    SlickDepoimentos,
    SinSaudePlanos
  },
  computed: {
    formBusca () {
      return this.$store.getters.formBusca
    },
    exibeConhecaNossosPlanos () {
      return false
    }
  },
  mounted () {
    let recoverToken = this.$route.query.recover
    if (recoverToken) {
      eventBus.$emit('openModal', 'changePassword')
    }
  },
  methods: {
    scrollMeTo (refName) {
      var element = this.$refs[refName]
      var top = element.offsetTop

      window.scrollTo(0, top)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/pages/Home.vue